import { css, keyframes } from 'styled-components/macro'

import { gradients } from './colors'

export const flexColumnNoWrap = css`
  display: flex;
  flex-flow: column nowrap;
`

export const flexRowNoWrap = css`
  display: flex;
  flex-flow: row nowrap;
`

interface GradientBorderOptions {
  borderWidth?: number
  sides?: {
    top?: boolean
    right?: boolean
    bottom?: boolean
    left?: boolean
  }
}

/**
 * Gradient border utility using pseudo-element to support border-radius.
 * @param gradient - CSS gradient string (e.g., 'linear-gradient(180deg, #814464 0%, rgba(44, 13, 29, 0) 100%)')
 * @param options - Border width and which sides to show (default: all sides with 1px width)
 */
export const gradientBorder = (gradient: string, options: GradientBorderOptions = {}) => {
  const { borderWidth = 1, sides = { top: true, right: true, bottom: true, left: true } } = options
  const { top = true, right = true, bottom = true, left = true } = sides

  const paddingTop = top ? borderWidth : 0
  const paddingRight = right ? borderWidth : 0
  const paddingBottom = bottom ? borderWidth : 0
  const paddingLeft = left ? borderWidth : 0

  return css`
    &::before {
      content: '';
      width: calc(100% - ${borderWidth * 2}px);
      position: absolute;
      inset: 0;
      border-radius: inherit;
      padding: ${paddingTop}px ${paddingRight}px ${paddingBottom}px ${paddingLeft}px;
      background: ${gradient};
      -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      pointer-events: none;
    }
  `
}

export const gradientBorderPrimary = gradientBorder(gradients.gradientBorderPrimary)
export const gradientBorderSecondary = gradientBorder(gradients.gradientBorderSecondary)
export const gradientBorderTertiary = gradientBorder(gradients.gradientBorderTertiary)

export enum TRANSITION_DURATIONS {
  slow = 500,
  medium = 250,
  fast = 125,
}

const transitions = {
  duration: {
    slow: `${TRANSITION_DURATIONS.slow}ms`,
    medium: `${TRANSITION_DURATIONS.medium}ms`,
    fast: `${TRANSITION_DURATIONS.fast}ms`,
  },
  timing: {
    ease: 'ease',
    in: 'ease-in',
    out: 'ease-out',
    inOut: 'ease-in-out',
  },
}

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

export const textFadeIn = css`
  animation: ${fadeIn} ${transitions.duration.fast} ${transitions.timing.in};
`
